import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import config from '../config'
import { COLORS, SIZES } from '../styles/theme'
import { useDispatch, useSelector } from 'react-redux'
import { loginUser } from '../ducks/auth'
import { Redirect } from 'react-router-dom'
import ForgetPassword from '../components/ForgetPassword'
import routes from '../routes'

import whiteArrow from '../images/right-arrow-white.png'
import { toast } from 'react-toastify'

const PageWrapper = styled.div`
  ${SIZES.mobile} {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    min-height: 100vh;
    max-height: auto;
  }
`

const LoginBox = styled.section`
  position: fixed;
  bottom: 5vh;
  right: 0vw;
  padding: 4vw;
  padding-bottom: 0;
  max-height: 100%;
  text-align: center;
  color: white;

  .action-text {
    font-weight: bold;
    color: #279AAC;
    cursor: pointer;
  }
  
  form {
    background: #FFF;
    color: #404040;
    padding: 30px 10px;
    border-radius: 28px;
    margin: auto;
    margin-top: 30px;
    max-width: 375px;

    input {
      width: 80%;
      background: ${COLORS.lightGray};
      border: none;
      padding: 12px 28px;
      border-radius: 20px;
      margin-top: 20px;
      
      &::placeholder {
        color: ${COLORS.lightGray1};
      }
    }
    
    .forget-pass {
      width: 80%;
      color: ${COLORS.primaryTrans};
      margin-top: 10px;
      font-size: 0.9em;
    }
    
    .login-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      /* width: 10%; */
      width: 60px;
      height: 60px;
      margin: auto;
      margin-top: 1em;
      margin-bottom: 0em;
      border-radius: 50%;
      letter-spacing: 1px;
      background: linear-gradient(0deg, #012261, #083970, #2595a9);
      cursor: pointer;
      opacity: 1;
      outline: none;
      input {
        cursor: pointer;
        opacity: 0;
        padding: 0;
        margin: 0;
        display: none;
      }
      div {
        line-height: 60px;
      }
    }
    
    .white-arrow {
      width: 24px;
      line-height: 60px;
      /* margin-left: -6px; */
      cursor: pointer;
    }
    
    .title {
      font-weight: 500;
      font-size: 20px;
      margin: 0;
      color: #404040;
    }
  }

  /* .form-check {
    display: none;
  } */

  div.privacy {
    margin: 0 auto;
    width: 90%;
    margin-top: 12px;
  }
  .form-check {
    display: flex;
    align-items: flex-start;
    padding: 0;
    font-weight: 500;
    .agree-box {
      padding: 8px;
      margin-top: 4px;
      width: 20%;
    }
    .form-check-label {
      color: #404040;
      font-size: 11px;
      margin-left: 8px;
      a {
        text-decoration: underline;
      }
    }
  }
  
  ${SIZES.mobile} {
    position: static;
    padding: 6px 0;
    
    form {
      border-radius: 10px;
    }
  }
  `
  const Privacy = styled.section`
    position: fixed;
    bottom: 21vh;
    left: 4vw;
    width: 50%;
    padding: 16px;
    max-height: 100%;
    text-align: center;
    color: #404040;
    background-color: rgba(255, 255, 255, 0.85);
    .form-check {
      display: flex;
      align-items: flex-start;
      padding: 0;
      font-weight: 500;
      .agree-box {
        padding: 8px;
      }
      .form-check-label {
        color: #404040;
        font-size: 12px;
        margin-left: 8px;
        a {
          text-decoration: underline;
        }
      }
    }
    ${SIZES.mobile} {
      display: none;
    }
  `

export default function LoginPage() {
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [agree, setAgree] = useState(false)
  const [expand, setExpand] = useState(false)

  const { isFetching, isAuthenticated } = useSelector((state) => state.auth)
  const dispatch = useDispatch()

  const handleCheckBox = (e) => {
    const { checked } = e.target
    setAgree (checked)
    setExpand (true)
  }

  const handleExpand = () => {
    setExpand(!expand)
  }


  const handleLogin = (e) => {
    e.preventDefault()
    if(!agree) {
      toast("Please indicate that you have read and agree to the Terms and Conditions and Privacy Notice before login")
      return
    }
    dispatch(
      loginUser({
        email,
        password,
      })
    )
  }

  const onPasswordInput = (e) => {
    setPassword(e.target.value)
  }

  const onEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }

  useEffect(() => {
    document.title = `${config.eventName} | Login`
  }, [])

  if (isAuthenticated) {
    return <Redirect to={routes.lobby} />
  } else {
    return (
      <PageWrapper>
        {/* <Privacy>
          <div className="form-check">
            <input 
              type="checkbox"
              className="agree-box" 
              onChange={handleCheckBox}
            />
            <label className="form-check-label text-left">
              <span className="text-danger">*</span>&nbsp;
              I hereby acknowledge that I have read and understood this&nbsp;
              <a href="https://drive.google.com/file/d/1q7RkRFb8iQUP1cRx4onkws0HXShChNL1/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                Personal Data Protection Provacy Notice
              </a>
              . By checking this box, I acknowledge agreeing to the registration terms and conditions as well as consent to the processing of my personal data in accordance with the terms of this provacy notice.
            </label>
          </div>
        </Privacy> */}
        <LoginBox>
          <>
            <form onSubmit={handleLogin}>
              <p className="title">Login</p>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={onEmailInput}
              />
              <input
                type="password"
                value={password}
                placeholder="Password"
                onChange={onPasswordInput}
              />

              <div className="privacy mb-2">
                <div className="form-check">
                  <input 
                    type="checkbox"
                    className="agree-box" 
                    onChange={handleCheckBox}
                  />
                  <label className="form-check-label text-left">
                    <span className="text-danger">*</span>&nbsp;
                    I hereby acknowledge that I have read and understood this&nbsp;
                    <a href="https://drive.google.com/file/d/1q7RkRFb8iQUP1cRx4onkws0HXShChNL1/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                      Personal Data Protection Privacy Notice
                    </a>
                    {
                      expand ?
                      <span onClick={handleExpand}>
                      . By checking this box, I acknowledge agreeing to the registration terms and conditions as well as consent to the processing of my personal data in accordance with the terms of this privacy notice.
                      </span>
                      :
                      <span onClick={handleExpand} className="text-secondary font-weight-bold">...&nbsp;&nbsp;Read More</span>
                    }
                  </label>
                </div>
              </div>
              
              <span className="text-secondary font-weight-bold">Create Account/Forgot Password?&nbsp;</span>
              <a href="https://www.namaseanaaa2021.com/login#requestPassword" target="_blank" rel="noopener noreferrer">
                <p className="action-text">Click Here</p>
              </a>
              {/* <ForgetPassword>
                <span className="text-secondary font-weight-bold">Forgot Password?&nbsp;</span>
                <span className="action-text">Click Here</span>
              </ForgetPassword> */}
              <div className="btn login-btn" style={{ background: isFetching ? 'lightgray' : 'linear-gradient(0deg, #012261, #083970, #2595a9)'}}>
                <input
                  disabled={!(email.length && password.length) || isFetching}
                  type="submit"
                  value={isFetching ? '' : ''}
                  // className="btn login-btn"
                />
                <div>
                  <img src={whiteArrow} className="white-arrow" onClick={handleLogin} />
                </div>
              </div>

            </form>
          </>
        </LoginBox>
      </PageWrapper>    
    )
  }
}
